import { TIPO_FICHERO } from "api/Types/TipoFichero"

const mimeToFileType: {
  [key: string]: (typeof TIPO_FICHERO)[keyof typeof TIPO_FICHERO]
} = {
  // Imágenes
  "image/jpeg": TIPO_FICHERO.IMAGEN,
  "image/png": TIPO_FICHERO.IMAGEN,
  "image/gif": TIPO_FICHERO.IMAGEN,
  "image/bmp": TIPO_FICHERO.IMAGEN,
  "image/webp": TIPO_FICHERO.IMAGEN,
  "image/tiff": TIPO_FICHERO.IMAGEN,
  "image/x-icon": TIPO_FICHERO.IMAGEN,
  "image/vnd.microsoft.icon": TIPO_FICHERO.IMAGEN,
  "image/svg+xml": TIPO_FICHERO.IMAGEN,

  // PDFs
  "application/pdf": TIPO_FICHERO.PDF,

  // Texto
  "text/plain": TIPO_FICHERO.TEXTO,

  // Excel
  "application/vnd.ms-excel": TIPO_FICHERO.EXCEL,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    TIPO_FICHERO.EXCEL,

  // Word
  "application/msword": TIPO_FICHERO.DOC,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    TIPO_FICHERO.DOC,

  // CSV
  "text/csv": TIPO_FICHERO.CSV,

  // XML
  "application/xml": TIPO_FICHERO.XLM,
  "text/xml": TIPO_FICHERO.XLM,
}

export const getFileType = (
  fileType: string | null
): (typeof TIPO_FICHERO)[keyof typeof TIPO_FICHERO] => {
  return fileType ? mimeToFileType[fileType] : TIPO_FICHERO.DESCONOCIDO
}
